import CmtCard from '@coremat/CmtCard';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import { Box, Button, Divider, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';

const actionButtonSx = {
  borderRadius: 2,
  maxHeight: 46,
  backgroundColor: '#fff',
  borderColor: '#000',
  borderWidth: 1,
  borderStyle: 'solid',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#E8E9EB',
    boxShadow: 'none',
  },
};

const useStyles = makeStyles(() => ({
  itemCardContent: () => ({
    padding: 0,
    position: 'relative',
    height: '100%',
  }),
  itemCard: () => ({
    borderRadius: 0,
    height: '100%',
  }),
  promoBadge: {
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: 'rgba(255, 221, 0, 0.88)',
    color: 'black',
    padding: '6px 24px',
    fontWeight: 'bold',
    fontSize: 18,
    zIndex: 1,
  },
}));

const DealerPortalMenuToolingCard = ({ product, view, onClick, onPrimaryAction }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const isCard = view === 'card';

  const formattedDescription = useMemo(() => (product?.shortDescription || '').split('\n').join('<br />'), [product]);

  return (
    <CmtCard className={classes.itemCard}>
      <CmtCardContent className={classes.itemCardContent}>
        <Box
          display="flex"
          flexDirection={isCard ? 'column' : 'row'}
          justifyContent="space-between"
          width="100%"
          height="100%">
          <Box minWidth="250px" onClick={onClick} display="flex" flexDirection={isCard ? 'column' : 'row'}>
            <Box textAlign="center">
              <Box
                component="img"
                src={product?.imgSrc}
                alt={product?.name || 'product-image'}
                sx={{
                  width: isCard ? '100%' : '25vw',
                  display: 'block',
                  height: '300px',
                  objectFit: 'contain',
                  cursor: onClick ? 'pointer' : 'default',
                }}
              />

              {isCard && <Divider sx={{ mt: 2, mx: 2 }} />}
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              sx={{ mt: 2, px: 4, cursor: onClick ? 'pointer' : 'default' }}>
              <Typography variant="h3" sx={{ mb: 2, textTransform: 'uppercase' }}>
                {product?.name}
              </Typography>

              <Typography fontSize={12} sx={{ mb: 1 }}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: formattedDescription,
                  }}
                />
              </Typography>
            </Box>
          </Box>

          <Box sx={{ pt: 4 }}>
            <Box
              display="flex"
              flexDirection={isCard ? 'row' : 'column'}
              justifyContent={isCard ? 'space-between' : 'flex-end'}
              sx={{ px: 4, height: '100%' }}>
              <Box onClick={onClick} sx={{ cursor: onClick ? 'pointer' : 'default', py: isCard ? 0 : 3 }}>
                {product?.price > 0 && (
                  <Typography color="text.secondary">
                    <Box sx={{ pt: 3 }} />
                    <Typography variant="h4" color="text.primary" sx={{ fontWeight: 'bold' }}>
                      ${product?.price?.toFixed(2)} {product?.currencyName}
                    </Typography>
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-end',
                  flexDirection: isCard ? 'row' : 'column',
                  pointerEvents: 'auto',
                }}>
                <Button sx={actionButtonSx} variant="contained" color="secondary" onClick={onPrimaryAction}>
                  <Typography
                    sx={{
                      color: 'black !important',
                      fontSize: 22,
                      fontWeight: 800,
                      px: 0,
                      py: 2,
                      fontFamily: 'Trade Gothic Next LT Pro',
                      letterSpacing: '-0.02em',
                      mb: 1,
                    }}>
                    {product?.hasAdditionalToolings ? t('setUp') : t('addToCart')}
                  </Typography>
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </CmtCardContent>
    </CmtCard>
  );
};

export default DealerPortalMenuToolingCard;
